module.exports = __webpack_public_path__ + "img/egwonder64_ua.3e456cb2.webp";